// TODO(tsgo): Remove when microsoft/typescript-go#1034 is fixed (check after tsgo 7.1+)
import { adjustInventory } from "./schema/adjust-inventory";
import { exportAdjustmentHistory } from "./schema/adjustment-history/export-adjustment-history";
import { listAdjustmentHistory } from "./schema/adjustment-history/list-adjustment-history";
import { cancelAdjustmentSession } from "./schema/adjustment-session/cancel-adjustment-session";
import { createAdjustmentSession } from "./schema/adjustment-session/create-adjustment-session";
import { editAdjustmentSession } from "./schema/adjustment-session/edit-adjustment-session";
import { getAdjustmentSession } from "./schema/adjustment-session/get-adjustment-session";
import { listAdjustmentSessions } from "./schema/adjustment-session/list-adjustment-sessions";
import {
  searchAdjustmentSessions,
  searchAdjustmentSessionsCount,
  searchAdjustmentSessionsUniqueValues,
} from "./schema/adjustment-session/search-adjustment-sessions";
import { submitAdjustmentSession } from "./schema/adjustment-session/submit-adjustment-session";
import { undoAdjustmentSession } from "./schema/adjustment-session/undo-adjustment-session";
import { updateAdjustmentSession } from "./schema/adjustment-session/update-adjustment-session";
import { bulkDeleteBillOfMaterials } from "./schema/bill-of-materials/bulk-delete-bill-of-materials";
import { bulkUpdateBillOfMaterials } from "./schema/bill-of-materials/bulk-update-bill-of-materials";
import { createBillOfMaterials } from "./schema/bill-of-materials/create-bill-of-materials";
import { deleteBillOfMaterials } from "./schema/bill-of-materials/delete-bill-of-materials";
import { deleteBillOfMaterialsLocation } from "./schema/bill-of-materials/delete-bill-of-materials-location";
import { getBillOfMaterials } from "./schema/bill-of-materials/get-bill-of-materials";
import { getBillOfMaterialsByOutputProducts } from "./schema/bill-of-materials/get-bill-of-materials-by-output-products";
import { getBillOfMaterialsList } from "./schema/bill-of-materials/get-bill-of-materials-list";
import { getBillOfMaterialsLocations } from "./schema/bill-of-materials/get-bill-of-materials-locations";
import { getBillOfMaterialsTags } from "./schema/bill-of-materials/get-bill-of-materials-tags";
import { getBomProductionCapacity } from "./schema/bill-of-materials/get-bom-production-capacity";
import { recordBomDisassembly } from "./schema/bill-of-materials/record-bom-disassembly";
import { recordBomProduction } from "./schema/bill-of-materials/record-bom-production";
import { searchBillOfMaterials } from "./schema/bill-of-materials/search-bill-of-materials";
import { updateBillOfMaterials } from "./schema/bill-of-materials/update-bill-of-materials";
import { updateBillOfMaterialsLocation } from "./schema/bill-of-materials/update-bill-of-materials-location";
import { uploadBillOfMaterialsCsv } from "./schema/bill-of-materials/upload-bill-of-materials-csv";
import { createAttributeDefinition } from "./schema/create-attribute-definition";
import { deleteAttributeDefinition } from "./schema/delete-attribute-definition";
import { getAttributeValues } from "./schema/get-attribute-values";
import { listAttributeDefinitions } from "./schema/list-attribute-definitions";
import { checkSkuAvailability } from "./schema/product-catalog/check-sku-availability";
import { updateAttributeDefinition } from "./schema/update-attribute-definition";

export const groupA = {
  adjustInventory,
  checkSkuAvailability,
  cancelAdjustmentSession,
  createAdjustmentSession,
  editAdjustmentSession,
  getAdjustmentSession,
  listAdjustmentSessions,
  searchAdjustmentSessions,
  searchAdjustmentSessionsCount,
  searchAdjustmentSessionsUniqueValues,
  submitAdjustmentSession,
  undoAdjustmentSession,
  updateAdjustmentSession,
  exportAdjustmentHistory,
  listAdjustmentHistory,
  createAttributeDefinition,
  deleteAttributeDefinition,
  getAttributeValues,
  listAttributeDefinitions,
  updateAttributeDefinition,
  bulkDeleteBillOfMaterials,
  bulkUpdateBillOfMaterials,
  createBillOfMaterials,
  deleteBillOfMaterials,
  deleteBillOfMaterialsLocation,
  getBillOfMaterials,
  getBomProductionCapacity,
  recordBomProduction,
  recordBomDisassembly,
  getBillOfMaterialsByOutputProducts,
  getBillOfMaterialsList,
  getBillOfMaterialsLocations,
  getBillOfMaterialsTags,
  searchBillOfMaterials,
  updateBillOfMaterials,
  updateBillOfMaterialsLocation,
  uploadBillOfMaterialsCsv,
};
